import jwtDecode from 'jwt-decode';
import { getUnixTime } from '../date';

const isExpired = token => {
  const { exp } = jwtDecode(token);

  return getUnixTime() >= exp - 300;
};

export default isExpired;
